import React, { Component } from 'react';
import Button from '~/UI/Button';
import buttonPrimaryWideStyles from '~/UI/Button/primary-wide.less';
import FormFieldError from '~/UI/FormFieldError/FormFieldError';
import Heading from '~/UI/Heading/Heading';
import Input from '~/UI/Input/Input';
import wideInputStyles from '~/UI/Input/wide.less';

import styles from './styles.less';

interface Props {
	isFetching: boolean;
	onResetPassword(email: string): Promise<{ emailError: string | null }>;
}

interface State {
	email: string;
	emailError: string | null;
}

export default class PasswordResetPage extends Component<Props, State> {
	state = {
		email: '',
		emailError: null,
	};

	handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		const {
			state: { email },
			props: { onResetPassword },
		} = this;

		event.preventDefault();
		this.setState({ emailError: null });

		onResetPassword(email.trim()).then((errors) => {
			if (errors.emailError !== null) {
				this.setState(errors);
			}
		});
	};

	render() {
		const {
			props: { isFetching },
			state: { email, emailError },
		} = this;

		return (
			<section className={styles.section}>
				<div className={styles.in}>
					<form data-testid='request-form' onSubmit={this.handleFormSubmit}>
						<Heading>Request new password</Heading>

						<div className={styles.form}>
							<Input
								disabled={isFetching}
								isInvalid={emailError !== null}
								name='email'
								placeholder='Email'
								styles={wideInputStyles}
								value={email}
								onChange={(event) => this.setState({ email: event.currentTarget.value })}
							/>
							{emailError !== null ? <FormFieldError>{emailError}</FormFieldError> : null}

							<Button disabled={email === '' || isFetching} styles={buttonPrimaryWideStyles}>
								Reset password
							</Button>
						</div>
					</form>
				</div>
			</section>
		);
	}
}
